<template>
  <div class="applyInWayBox">
    <div class="w-12">
      <p class="examName">{{ $store.state.examInfo.examName }}</p>
      <ul>
        <!--  v-if="
            new Date($store.state.examInfo.applyEnd).getTime() >
            new Date().getTime()
          " -->
        <li class="itemBox" v-if="isApply">
          <span style="flex: 1">报名、修改、查看入口</span>
          <span>
            报名时间:&nbsp;{{ $store.state.examInfo.applyStart }}&nbsp;—&nbsp;
          </span>
          <span>{{ $store.state.examInfo.applyEnd }}</span>
          <el-button
            :disabled="$store.state.examInfo.status == '0'"
            type="primary"
            size="mini"
            style="margin-left: 20px"
            @click="toExamDetail"
          >
            进入
          </el-button>
        </li>
        <!-- 查看入口 -->
        <li class="itemBox" v-if="isCheck">
          <span style="flex: 1">报名查看入口</span>
          <span>
            开放时间:&nbsp;{{ $store.state.examInfo.applyEnd }}&nbsp;—&nbsp;
          </span>
          <span>{{ checkEndDate }}</span>
          <el-button
            :disabled="$store.state.examInfo.status == '0'"
            type="primary"
            size="mini"
            style="margin-left: 20px"
            @click="toExamDetail('check')"
          >
            进入
          </el-button>
        </li>
        <li class="itemBox" v-if="isPrint">
          <span style="flex: 1">打印准考证入口</span>
          <span>
            打印时间:&nbsp;{{ $store.state.examInfo.printStart }}&nbsp;—&nbsp;
          </span>
          <span>{{ $store.state.examInfo.printEnd }}</span>
          <el-button
            :disabled="$store.state.examInfo.status == '0'"
            type="primary"
            size="mini"
            style="margin-left: 20px"
            @click="toPrint"
          >
            进入
          </el-button>
        </li>
        <li class="itemBox" v-if="isCheckScore">
          <span style="flex: 1">查分入口</span>
          <span>
            查分时间:&nbsp;{{ examInfo.searchscoreStart }}&nbsp;—&nbsp;
          </span>
          <span>{{ examInfo.searchscoreEnd }}</span>
          <el-button
            type="primary"
            size="mini"
            style="margin-left: 20px"
            @click="toCheckScore"
          >
            进入
          </el-button>
        </li>
        <!-- <li class="itemBox" v-if="isUpdate && !isCheck">
          <span style="flex: 1">修改入口</span>
          <span>
            修改时间:&nbsp;{{ $store.state.examInfo.applyEnd }}&nbsp;—&nbsp;
          </span>
          <span>{{ $store.state.examInfo.checkEnd }}</span>
          <el-button
            :disabled="$store.state.examInfo.status == '0'"
            type="primary"
            size="mini"
            style="margin-left: 20px"
            @click="toApplyBaseInfo"
          >
            进入
          </el-button>
        </li> -->
        <p style="text-align: center; margin-top: 150px">
          <strong style="color: #fa6363; font-size: 25px">{{
            $store.state.examInfo.notice
          }}</strong>
        </p>
      </ul>
    </div>
  </div>
</template>
<script>
import { updataUserInfo } from "../../api/personal";
import { getApplyInfo } from "@/api/apply";

export default {
  name: "ExamInfo",
  data() {
    return {
      examInfo: {},
      enterDisabled: false,
      isApply: false,
      isPrint: false,
      isUpdate: false,
      isCheck: false,
      isCheckScore: false,
      checkEndDate: null,
      applyDetail: {},
    };
  },
  mounted() {
    let _that = this;
    if (window.sessionStorage.getItem("applyToken")) {
      getApplyInfo({
        examId: this.$store.state.examId,
      }).then((res) => {
        console.log(res);
        if (res.data.success) {
          _that.applyDetail = res.data.obj.applyDetail;
        }
      });
    }
    let reg = new RegExp("-", "g");
    let timerfirst = setInterval(() => {
      if (window.groundParentMounted) {
        _that.examInfo = _that.$store.state.examInfo;

        // 报名入口 开放
        let datestr1 = _that.$store.state.examInfo.applyEnd.replace(reg, "/");
        let datestr2 = _that.$store.state.examInfo.checkEnd.replace(reg, "/");
        _that.isApply = new Date(datestr1).getTime() > new Date().getTime();
        // console.log(JSON.stringify(this.applyDetail));

        // 报名信息修改入口 开放
        _that.isUpdate =
          new Date(datestr1).getTime() < new Date().getTime() &&
          new Date(datestr2).getTime() > new Date().getTime() &&
          JSON.stringify(this.applyDetail) !== "null";

        // 准考证打印入口 开放
        if (_that.$store.state.examInfo.printStart) {
          let datestr2 = _that.$store.state.examInfo.printStart.replace(
            reg,
            "/"
          );
          if (_that.$store.state.examInfo.printEnd) {
            let datestr3 = _that.$store.state.examInfo.printEnd.replace(
              reg,
              "/"
            );
            _that.isPrint =
              new Date(datestr3).getTime() > new Date().getTime() &&
              new Date(datestr2).getTime() < new Date().getTime();
          } else {
            _that.isPrint = new Date(datestr2).getTime() < new Date().getTime();
          }
        }

        // 报名查看入口 开放
        let nowDate = new Date().getTime();
        let endDate = new Date(_that.$store.state.examInfo.applyEnd).getTime();
        // 报考结束后可查看时间
        let checkDays = 0
        let endDate2 = endDate + 60 * 60 * 24 * 1000 * checkDays;
        if (nowDate > endDate && nowDate < endDate2) {
          _that.isCheck = true;
        }
        _that.checkEndDate = _that.handleDateAdd(
          _that.$store.state.examInfo.applyEnd
        );

        // 查分入口
        if (_that.$store.state.examInfo.searchscoreStart) {
          _that.isCheckScore =
            new Date(_that.examInfo.searchscoreStart).getTime() <
              new Date().getTime() &&
            new Date(_that.examInfo.searchscoreEnd).getTime() >
              new Date().getTime();
        }

        clearInterval(timerfirst);
      }
    }, 500);
  },
  methods: {
    toExamDetail(type) {
      // 判登录
      if (!sessionStorage.getItem("userInfo")) {
        this.$router.push(`/login?examId=${this.$store.state.examId}`);
        return;
      }
      sessionStorage.removeItem("applyType");
      if (type && type == "check") {
        sessionStorage.setItem("applyType", "check");
        this.$router.push("/apply/applyCommitment");
      } else {
        this.$router.push("/apply/guide");
      }
    },
    // 打印准考证
    toPrint() {
      // 判登录
      if (!sessionStorage.getItem("userInfo")) {
        this.$router.push(`/login?examId=${this.$store.state.examId}`);
        return;
      }
      this.$router.push("/apply/applyPrintAdmission?type=print");
    },
    // 查分
    toCheckScore() {
      // 判登录
      if (!sessionStorage.getItem("userInfo")) {
        this.$router.push(`/login?examId=${this.$store.state.examId}`);
        return;
      }
      this.$router.push("/apply/applyAnnounceResults?type=checkScore");
    },
    toApplyBaseInfo() {
      // 判登录
      if (!sessionStorage.getItem("userInfo")) {
        this.$router.push(`/login?examId=${this.$store.state.examId}`);
        return;
      }
      this.$router.push("/apply/applyBaseInfo");
    },
    // 时间加一天
    handleDateAdd(str) {
      let dateStr = str.substr(0, 10);
      let timeStr = str.substr(10, str.length - 1);
      // console.log(dateStr);
      // console.log(timeStr);
      let date = new Date(dateStr);
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 > 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      let day =
        date.getDate() + 3 > 10
          ? date.getDate() + 3
          : "0" + (date.getDate() + 3);
      return year + "-" + month + "-" + day + timeStr;
    },
  },
};
</script>
<style scoped>
.applyInWayBox {
  padding-top: 100px;
  height: 100%;
  background: url("../../assets/images/background_img.svg");
  background-size: cover;
}

.examName {
  font-size: 23px;
  font-weight: bold;
  line-height: 2;
  letter-spacing: 1px;
}

.itemBox {
  display: flex;
  height: 40px;
  align-items: center;
  border: 1px solid #ccc;
  padding: 0 15px;
  font-size: 23px;
  margin-top: 10px;
}

.itemBox-last {
  border-bottom: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/apply/ExamInfo.vue